
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <h2 class="mt-3">Collapse Notification</h2>
    <collapse-notification
      v-for="(notification, index) in notifications"
      :key="index"
      :notification="notification"
      :id="'colpase-' + index"
      visible
    ></collapse-notification>
    <h2 class="mt-3">Card with button Collapse</h2>
    <collapse-card id="card-collapse" visible>
      <template v-slot:title> Title </template>
      <template v-slot:body>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta id
        maxime quasi nihil ipsa tempora sapiente facere? Quia voluptatibus quam
        natus, enim ratione autem ex numquam dolorum fugit veritatis ut
        blanditiis, repudiandae ipsum aperiam, minima vero alias nulla
        exercitationem facere? Quo, nesciunt temporibus excepturi voluptatum
        incidunt voluptatem veniam. Voluptas magnam vel voluptatibus,
        repudiandae numquam perspiciatis quis neque odio incidunt accusantium
        beatae nobis!
      </template>
    </collapse-card>
    <h2 class="mt-3">Card normal</h2>
    <collapse-card id="card" visible :noButton="true" :noTitlePrimary="true">
      <template v-slot:title> Title </template>
      <template v-slot:body>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dicta id
        maxime quasi nihil ipsa tempora sapiente facere? Quia voluptatibus quam
        natus, enim ratione autem ex numquam dolorum fugit veritatis ut
        blanditiis, repudiandae ipsum aperiam, minima vero alias nulla
        exercitationem facere?
      </template>
    </collapse-card>

    <h2 class="mt-3">Modals</h2>
    <b-button @click="openModal()" class="mr-2"> Open Modal</b-button>

    <b-modal
      id="modal"
      modal-class="p-4 big-modal"
      content-class="text-center pb-5"
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-footer
      lazy
    >
      <b-icon
        icon="x"
        @click="hideModal()"
        class="icon-close fsize-5 text-muted"
      ></b-icon>

      <div class="py-5 px-sm-4 p-md-5">
        <h2 class="text-primary mb-4 mt-5 font-45px">Title</h2>
        <b-row>
          <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
            <b-card
              class="border-raduis-xl border-color-muted box-shadow-sm"
              body-class="py-5 p-sm-5"
            >
              <b-row>
                <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                  Body
                </b-col>
              </b-row>
            </b-card>
            <b-card
              class="border-raduis-xl border-color-muted box-shadow-sm mt-4"
              body-class="p-3"
            >
              <b-row>
                <b-col cols="12" sm="6" class="text-sm-right mb-2 mb-sm-0">
                  <b-button
                    @click="hideModal()"
                    pill
                    variant="outline-primary"
                    class="py-2 px-5"
                  >
                    <span>Cancel</span>
                  </b-button>
                </b-col>
                <b-col cols="12" sm="6" class="text-sm-left">
                  <b-button
                    @click="hideModal()"
                    pill
                    variant="primary"
                    class="py-2 px-5"
                  >
                    <span>Ok</span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-button @click="openModalWhiteBg()"> Open Modal BG</b-button>
    <b-modal
      id="modal-bg"
      modal-class="modal-notification"
      content-class="text-center pb-5"
      size="md"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      centered
      lazy
    >
      <div
        class="h-100 d-flex flex-column align-items-center justify-content-end px-5 py-2"
      >
        <h3 class="font-weight-light">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum, ex?
        </h3>

        <b-button
          data-cy="submit"
          type="submit"
          variant="success"
          pill
          size="lg"
          class="btn-px-xl mt-4"
          @click="hideModalWhiteBg()"
          >OK</b-button
        >
      </div>
    </b-modal>

    <h2 class="mt-3">vue notification</h2>
    <b-button @click="vueAllNotification()" class="mr-2">
      Vue Notification</b-button
    >
    <h2 class="mt-3">Form</h2>

    <b-card class="border-raduis-xl border-0 box-shadow-sm">
      <b-form-row no-gutters class="mt-4 c-form align-items-end">
        <b-col cols="12">
          <b-form-group>
            <b-form-input
              class="border-raduis-xl border-color-success font-size-md"
              type="text"
              placeholder="Text"
            >
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Input group"
            label-for="input_group"
            label-class="fsize-1 font-weight-md"
          >
            <b-form-input
              placeholder="Input group"
              id="input_group"
              type="text"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Input disabled"
            label-for="input_disabled"
            label-class="fsize-1 font-weight-md"
          >
            <b-form-input
              placeholder="Input disabled"
              id="input_disabled"
              type="text"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Input disabled 2"
            label-for="input_group"
            label-class="fsize-1 font-weight-md"
          >
            <b-form-input
              placeholder="Input disabled 2"
              id="input_group"
              type="text"
              class="like-input"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Radios using options"
            label-class="fsize-1 font-weight-md"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-radio-group
              id="radio-group-1"
              v-model="selectedRadio"
              :options="optionsRadio"
              :aria-describedby="ariaDescribedby"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Checkboxs" label-class="fsize-1 font-weight-md">
            <b-form-checkbox
              id="checkbox1"
              name="checkbox1"
              value="0"
              class="big-checkbox-green"
            >
              <div class="label-content">Checkbox1</div>
            </b-form-checkbox>
            <b-form-checkbox
              id="checkbox2"
              name="checkbox2"
              value="0"
              class="big-checkbox-green"
            >
              <div class="label-content">Checkbox2</div>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="MultiSeelct"
            label-class="fsize-1 font-weight-md"
          >
            <multiselect
              v-model="multipleSlect"
              :options="multipleSlectOptions.options"
              :placeholder="multipleSlectOptions.placeholder"
              :multiple="multipleSlectOptions.multiple"
              trackBy="id"
              label="name"
              :showLabels="false"
              class="tags-outline with-chevron multiselect-md"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc d-flex justify-content-between">
                  <span class="option__title">{{ props.option.name }}</span>
                  <span
                    class="option__info-icon right"
                    :desc="props.option.info"
                  >
                    <b-icon class="text-muted" icon="info-circle"></b-icon>
                  </span>
                </div>
              </template>
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="singleSlect"
            label-class="fsize-1 font-weight-md"
          >
            <multiselect
              v-model="singleSlect"
              :options="singleSlectOptions.options"
              :placeholder="singleSlectOptions.placeholder"
              :multiple="singleSlectOptions.multiple"
              trackBy="id"
              label="name"
              :showLabels="false"
              class="tags-outline with-chevron multiselect-md"
            >
              <template slot="option" slot-scope="props">
                <div class="option__desc d-flex justify-content-between">
                  <span class="option__title">{{ props.option.name }}</span>
                  <span
                    class="option__info-icon right"
                    :desc="props.option.info"
                  >
                    <b-icon class="text-muted" icon="info-circle"></b-icon>
                  </span>
                </div>
              </template>
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Date picker"
            label-class="fsize-1 font-weight-md"
          >
            <b-form-datepicker
              v-model="datepicker"
              :locale="locale"
              placeholder="date"
              class="button-content-right"
              right
            >
              <template slot="button-content">
                <span class="text-primary">
                  <b-icon icon="calendar3"></b-icon>
                </span>
              </template>
            </b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-card>

    <h2 class="mt-3">Button</h2>
    <b-card class="border-raduis-xl border-0 box-shadow-sm mb-2">
      <b-button pill  class='mr-2 px-4' variant="primary">Primary</b-button> 
      <b-button pill  class='mr-2 px-4' variant="success">Success</b-button>
      <b-button pill  class='mr-2 px-4' variant="danger">Danger</b-button>
      <b-button pill  class='mr-2 px-4' variant="warning">Warning</b-button>
      <b-button pill  class='mr-2 px-4' variant="info">Info</b-button>
      <b-button pill  class='mr-2 px-4' variant="light">Light</b-button>
      <b-button pill  class='mr-2 px-4' variant="dark">Dark</b-button>
    </b-card>
    <b-card class="border-raduis-xl border-0 box-shadow-sm">
      <b-button pill class='mr-2 px-4' variant="outline-primary">Primary</b-button> 
      <b-button pill  class='mr-2 px-4' variant="outline-success">Success</b-button>
      <b-button pill  class='mr-2 px-4' variant="outline-danger">Danger</b-button>
      <b-button pill  class='mr-2 px-4' variant="outline-warning">Warning</b-button>
      <b-button pill  class='mr-2 px-4' variant="outline-info">Info</b-button>
      <b-button pill  class='mr-2 px-4' variant="outline-light">Light</b-button>
      <b-button pill  class='mr-2 px-4' variant="outline-dark">Dark</b-button>
    </b-card>
  </div>
</template>

<script>
import CollapseCard from '../../components/static/CollapseCard.vue';
import CollapseNotification from '../../components/static/CollapseNotification.vue';
export default {
  name: 'Components',
  data() {
    return {
      notifications: [
        {
          title: 'Villa De Gaulle',
          list: [
            {
              date: '26/02/2020 - 14H25',
              message: 'Statut de l <strong>’ouvrage</strong> mis à jour',
              content: ['Statut1', 'Statut2'],
            },
            {
              date: '26/02/2020 - 14H25',
              message: 'Statut de l <strong>’ouvrage</strong> mis à jour',
              content:
                'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l\'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte.',
            },
          ],
        },
      ],
      selectedRadio: null,
      optionsRadio: [
        { text: 'Yes', value: 'true' },
        { text: 'No', value: 'false' },
      ],
      multipleSlect: null,
      multipleSlectOptions: {
        placeholder: 'multipleSlect',
        multiple: true,
        options: [
          {
            id: 1,
            name: 'Attestation sur l’honneur',
            info: 'info',
          },
          {
            id: 2,
            name: 'Attestation',
            info: 'info',
          },
          {
            id: 3,
            name: 'Attestation',
            info: 'info',
          },
          {
            id: 4,
            name: 'Attestation',
            info: 'info',
          },
        ],
      },
      singleSlect: null,
      singleSlectOptions: {
        placeholder: 'singleSlect',
        multiple: false,
        options: [
          {
            id: 1,
            name: 'Attestation sur l’honneur',
            info: 'info',
          },
          {
            id: 2,
            name: 'Attestation',
            info: 'info',
          },
          {
            id: 3,
            name: 'Attestation',
            info: 'info',
          },
          {
            id: 4,
            name: 'Attestation',
            info: 'info',
          },
        ],
      },
      datepicker: null,
      locale: 'fr',
    };
  },
  components: { CollapseNotification, CollapseCard },
  computed: {},
  methods: {
    openModal() {
      this.$root.$emit('bv::show::modal', 'modal');
    },
    hideModal() {
      this.$root.$emit('bv::hide::modal', 'modal');
    },
    openModalWhiteBg() {
      this.$root.$emit('bv::show::modal', 'modal-bg');
    },
    hideModalWhiteBg() {
      this.$root.$emit('bv::hide::modal', 'modal-bg');
    },
    vueAllNotification() {
      const HELLO = 'hello world'
      this.$notification.new(HELLO);
      this.$notification.dark(HELLO);
      this.$notification.success(HELLO);
      this.$notification.warning(HELLO);
      this.$notification.error(HELLO);
    },
  },
};
</script>
